import { message } from 'antd';
import _ from 'lodash';
import ErrorMessageIcon from './assets/error-message-icon.svg';
import InfoMessageIcon from './assets/info-message-icon.svg';
import SuccessMessageIcon from './assets/success-message-icon.svg';
import WarningMessageIcon from './assets/warning-message-icon.svg';
import './message.scss';

/**
 * Shows a global success toast. Renders an antd success message carrying the custom-message class and the success icon around the given content.
 *
 * @param content - Success message to display.
 * @returns Nothing.
 */
const showMessageSuccess = ({ content }: any) => {
  message.success({
    className: 'custom-message',
    icon: <img src={SuccessMessageIcon} alt="Success message icon" />,
    content,
  });
};

/**
 * Shows a global error toast for a failed operation. Suppresses content mentioning Network error, Invalid access token, 403, 503 or 400 - the last unless it also mentions Exceeded maximum of - and otherwise renders an antd error message with the custom error icon.
 *
 * @param content - Error message to display.
 * @returns Nothing.
 */
const showMessageError = ({ content }: any) => {
  if (
    !_.includes(content, 'Network error') &&
    !_.includes(content, 'Invalid access token') &&
    !_.includes(content, '403') &&
    !_.includes(content, '503') &&
    (!_.includes(content, '400') || _.includes(content, 'Exceeded maximum of'))
  ) {
    message.error({
      className: 'custom-message',
      icon: <img src={ErrorMessageIcon} alt="Error message icon" />,
      content,
    });
  }
};

/**
 * Shows a global warning toast. Renders an antd warning message carrying the custom-message class and the warning icon around the given content.
 *
 * @param content - Warning message to display.
 * @returns Nothing.
 */
const showMessageWarning = ({ content }: any) => {
  message.warning({
    className: 'custom-message',
    icon: <img src={WarningMessageIcon} alt="Warning message icon" />,
    content,
  });
};

/**
 * Shows a global informational toast. Renders an antd info message carrying the custom-message class and the info icon around the given content.
 *
 * @param content - Informational message to display.
 * @returns Nothing.
 */
const showMessageInfo = ({ content }: any) => {
  message.info({
    className: 'custom-message',
    icon: <img src={InfoMessageIcon} alt="Info message icon" />,
    content,
  });
};

export { showMessageError, showMessageInfo, showMessageSuccess, showMessageWarning };
